import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ConfirmDelete } from '../../../decorators/confirmdelete.decorator';
import { brakediscpad } from '../../../interfaces/brakediscpad.interface';
import { Tyrebrand } from '../../../interfaces/tyrebrand.interface';
import { HelperService } from '../../../services/helper.service';
import { Vhcmodule } from '../../../vhcmodules/vhcmodule';

@Component({
  selector: 'app-qiscreen',
  templateUrl: './qiscreen.dialog.html',
  styleUrls: ['./qiscreen.dialog.scss'],
})
export class QiscreenDialog implements OnInit {

  @Input('description') description: string
  @Input('completed') completed: string
  @Input('qimodules') qimodules: Vhcmodule[]
  @Input('tyrebrands') tyrebrands:Tyrebrand[]
  @Input('brakediscpads') brakediscpads:brakediscpad[]
  constructor(private modalController: ModalController, private helper: HelperService) { }

  ngOnInit() {
    console.log(this.qimodules);
  }

  @ConfirmDelete()
  removeCSell(module, i) {
    module.data.splice(i,1)
  }

  async openQuestion(midx: number, qindex: number) {
    if (qindex == 0) {
      this.helper.notify('Opening questionblock ' + this.qimodules[midx].name)
    }
    let result = await this.qimodules[midx].openAnswer(qindex);
    if (result != undefined) {
      if (this.qimodules[midx].questions.length > qindex+1) {
        this.openQuestion(midx, qindex+1)
      } else {
        this.openModule(midx+1)
      }
    }
  }

  async openModule(midx,wasauto=false) {
    if (midx >= this.qimodules.length) {
      this.helper.notify('You have reached the end of the list')
      return;
    }
    if (this.qimodules[midx].type == 'Cross_cell' && wasauto) {
      this.helper.notify('You have reached the sales module')
      return;
    }
    if (this.qimodules[midx].type == 'Instruction') {
      this.helper.notify('instruction: ' + this.qimodules[midx].name)
      this.openModule(midx+1)
      return;
    }
    if (this.qimodules[midx].type == 'Questionblock') {
      this.openQuestion(midx, 0)
      return;
    }

    let ans;
    if (this.qimodules[midx].type == 'Tyres') {
      ans = await this.qimodules[midx].openAnswer(this.tyrebrands)
    } else if (this.qimodules[midx].type == 'Brakes') {
      ans = await this.qimodules[midx].openAnswer(this.brakediscpads)
    } else {
      ans = await this.qimodules[midx].openAnswer()
    }
    if (ans) {
      this.openModule(midx+1,true)
    }
  }

  dismissModal() {
    this.modalController.dismiss();
  }
  
  saveModal() {
    this.modalController.dismiss({savedata: true});
  }

  complete() {
    this.helper.promptYesNo('Do you want to complete the quality inspection?', 'The quality inspection will be finished and the next step will unlock.', ()=>{
      this.modalController.dismiss({completestep: true});
    }, 'Complete step', 'Cancel')
  }

}
